import { Navigate, Outlet } from 'react-router'

import { useSetupState } from '@/domains/setup'

import { FullPageSpinner } from './full-page-spinner'

/** gates supplier-only routes. a company holding a supplier role (supplier or
 *  both) may pass; a pure buyer is rerouted. always sits inside ProtectedRoute,
 *  so the caller is already authenticated. */
export function RequireSupplier({
  redirectTo = '/rfi'
}: {
  redirectTo?: string
}) {
  const { setupState } = useSetupState()
  if (!setupState) return <FullPageSpinner />
  if (!setupState.isSupplier) return <Navigate to={redirectTo} replace />
  return <Outlet />
}
